import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { BrandLockup } from "@/components/Logo";
import { SHOP } from "@/constants/testIds";

export default function Header({ inverse = false }) {
  const { count, setOpen } = useCart();
  const fg = inverse ? "text-[#FDF0DF]" : "text-[#14230A]";
  const border = inverse ? "border-[#FDF0DF]" : "border-[#14230A]";

  return (
    <header
      className={`sticky top-0 z-40 backdrop-blur-md border-b-2 ${border}`}
      style={{ background: inverse ? "rgba(20,35,10,0.9)" : "rgba(253,240,223,0.92)" }}
    >
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="/" className="flex items-center">
          <BrandLockup inverse={inverse} />
        </a>

        <div className="hidden md:flex items-center gap-8 font-cond uppercase tracking-[0.2em] text-xs">
          <a href="/#packs" className={`${fg} hover:text-[#FF4D00] transition-colors`}>Packs</a>
          <a href="/#catalog" className={`${fg} hover:text-[#FF4D00] transition-colors`}>Boutique</a>
          <a href="/jeu" className={`${fg} hover:text-[#FF4D00] transition-colors`}>Jeu</a>
          <a href="/#event" className={`${fg} hover:text-[#FF4D00] transition-colors`}>Le Festival</a>
        </div>

        <button
          onClick={() => setOpen(true)}
          data-testid={SHOP.headerCartBtn}
          className={`relative inline-flex items-center gap-2 px-3 md:px-4 h-10 md:h-11 border-2 ${border} ${fg} font-cond tracking-[0.15em] uppercase text-xs hover:bg-[#FF4D00] hover:text-[#FDF0DF] hover:border-[#FF4D00] transition-all`}
        >
          <ShoppingBag className="w-4 h-4" />
          <span className="hidden md:inline">Panier</span>
          {count > 0 && (
            <span
              data-testid={SHOP.headerCartCount}
              className="ml-1 inline-flex items-center justify-center min-w-[22px] h-[22px] bg-[#FF4D00] text-[#FDF0DF] text-[11px] font-bold px-1"
            >
              {count}
            </span>
          )}
        </button>
      </div>
    </header>
  );
}
